import { request } from '@/shared/api/request'

export const uploadFileEc = (payload) => {
	return request({
		url: `/file/s3/upload/ec`,
		method: 'POST',
		data: payload,
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	})
}
